// eslint-disable-next-line no-unused-vars
var graphParser = function() {
    console.warn('graphParser function called')
}

window['graphParser'] = { 
    init : function(modules) {  
      console.log("init graphParser::")
      let Device = modules.Device
      
      let newUrl = "";
      
      setInterval(() => {
        
        if(newUrl === window.location.pathname){
          return;
        }
        
        newUrl = window.location.pathname;
        
        // let metas = document.getElementsByTagName('meta');
        let meta = document.querySelectorAll('meta');
        // console.log("meta ==",meta)
        
        let title, type, ogType, description, url, site_name, image, price, amount, currency, availability, sku
        let isProduct = false
        
        for(let i=0;i<meta.length;i++){
          
          let property = meta[i].getAttribute('property');
          let content = meta[i].getAttribute('content');
          
          if(property && property.includes("og:")){
            let type = property.slice(property.indexOf(":") + 1);
            
            if(type == 'type'){
              type = ogType = meta[i].getAttribute('content')
            }
            
            if(type == 'type' && content=='product' ){
              isProduct = true
            }
            if(type == 'title'){
              title = meta[i].getAttribute('content')
            }
            if(type == 'description'){
              description = meta[i].getAttribute('content')
            }
            if(type == 'url'){
              url = meta[i].getAttribute('content')
            }
             if(type == 'site_name'){
              site_name = meta[i].getAttribute('content')
            }
            if(type == 'image'){
              image = meta[i].getAttribute('content')
            }
            if(type == 'availability'){
              availability = meta[i].getAttribute('content')
            }
            
            //Dynamic Type unlocks content value
            // if(type!= 'type'){
            //   console.log("device Unlock ::" + type  + " ::" + content)
            //   Device.queueUnlock(
            //     "OG.object.product",
            //     {
            //         type : content
            //     }
            //   )
            // }
          }
          
          if(isProduct && property && property.includes("product:")){
            console.log("isProduct ::")
            let productType = property.split(':').pop().split(':')[0]
            let pMetadata = property.slice(
              property.indexOf(':') + 1,
              property.lastIndexOf(':'),
            )
            
            if(pMetadata == 'price' && productType=="amount"){
              amount = meta[i].getAttribute('content')
            }
            if(pMetadata == 'price' && productType=="currency"){
              currency = meta[i].getAttribute('content')
            }
            
            if(productType=="SKU"){
              sku = meta[i].getAttribute('content')
            }
          }
        }
        
        //Basic Metadata Unlocks trigger here 
        if(ogType){
          Device.queueUnlock(
            "OG.basic."+ ogType,
            {   
                "title" : title,
                "url" : url,
                "image" : image,
                "site_name" : site_name,
                "description" : description,
                "availability": availability
            }
          )
        }
        
        //Product Metadata Unlocks trigger here 
        if(isProduct){
           Device.queueUnlock(
            "OG.product.metadata",
            {   
                "title" : title,
                "url" : url,
                "price" : amount,
                "currency" : currency,
                "SKU": sku
            }
        )
  
        }
        
      },200)
    }, 
    default : function () {
        console.log("Graph Parser default function calling")
        
    } 
}
